import React from 'react';
import PropTypes from 'prop-types';
import InputContainer from 'components/InputContainer';
import SelectAttribute from 'components/SelectAttribute';
import CheckBoxAttribute from 'components/Fields/CheckBoxAttribute';
import TextAreaAttribute from 'components/Fields/TextAreaAttribute';
import { FIELD_NAMES, FIELD_TYPES, GDPR_SETTING, LABEL_SUFFIX, OPTIN_FORMATS, OPTIN_RADIO_DEFAULTS } from 'utils/constants';
import {
  ERROR_TEXT_CHECKED_FIELD_NO_TEXT,
  ERROR_TEXT_EMPTY_REQUIRED_FIELD,
} from 'langs/en/errors';
import { generateHTMLIdFromKeyPath } from 'utils/idUtils';

import RadioGroupContainer from '../../RadioGroupContainer';
import RadioButtonAttribute from '../RadioButtonAttribute';

class FieldConfigureOptIn extends React.Component {

  componentDidMount() {
    const { type, name, editors: { optInData } } = this.props.values;
    if (type === FIELD_TYPES.BOOLEAN_OPT_IN && !optInData.optInValue) {
      this.onOptInValueChange([...this.props.keyPath, 'optInData', 'optInValue'], name);
    }
  }

  onDisclaimerCheckboxChange = (keyPath, value) => {
    this.props.onFieldValueChange(keyPath, value);
    if (!value) {
      this.props.fieldValidityChanged([...this.props.keyPath, 'optInData', 'disclaimer'], true);
    } else if (!this.props.values.editors.optInData.disclaimer.trim()) {
      this.props.fieldValidityChanged([...this.props.keyPath, 'optInData', 'disclaimer'], false, `${ERROR_TEXT_CHECKED_FIELD_NO_TEXT}`);
    }

    if (!this.props.values.editors.optInData.hasCheckbox) this.onProspectShareCheckboxChange([...this.props.keyPath, 'editors', 'optInData', 'hasCheckbox'], true);
  }

  onDisclaimerTextChange = (keyPath, value) => {
    this.props.onFieldValueChange(keyPath, value);

    if (!value.trim()) {
      this.props.fieldValidityChanged([...this.props.keyPath, 'optInData', 'disclaimer'], false, `${ERROR_TEXT_CHECKED_FIELD_NO_TEXT}`);
    } else {
      this.props.fieldValidityChanged([...this.props.keyPath, 'optInData', 'disclaimer'], true);
    }
  }

  onProspectShareCheckboxChange = (keyPath, value) => {
    this.props.onFieldValueChange(keyPath, value);
    this.props.onFieldUIStateChange([...this.props.keyPath, 'optInData', 'optInValue'], { required: value });
    if (value) {
      if (!this.props.values.editors.optInData.checkboxText.trim()) {
        this.props.fieldValidityChanged([...this.props.keyPath, 'optInData', 'checkboxText'], false, `${ERROR_TEXT_CHECKED_FIELD_NO_TEXT}`);
      }

      if (!this.props.values.editors.optInData.optInValue) {
        this.props.fieldValidityChanged([...this.props.keyPath, 'optInData', 'optInValue'], false, ERROR_TEXT_EMPTY_REQUIRED_FIELD);
      }
    } else {
      this.props.fieldValidityChanged([...this.props.keyPath, 'optInData', 'checkboxText'], true);
      this.props.fieldValidityChanged([...this.props.keyPath, 'optInData', 'optInValue'], true);
    }

    if (!this.props.values.editors.optInData.hasDisclaimer) this.onDisclaimerCheckboxChange([...this.props.keyPath, 'optInData', 'hasDisclaimer'], true);
  }

  onProspectShareTextChange = (keyPath, value) => {
    this.props.onFieldValueChange(keyPath, value);

    if (!value.trim()) {
      this.props.fieldValidityChanged([...this.props.keyPath, 'optInData', 'checkboxText'], false, `${ERROR_TEXT_CHECKED_FIELD_NO_TEXT}`);
    } else {
      this.props.fieldValidityChanged([...this.props.keyPath, 'optInData', 'checkboxText'], true);
    }
  }

  onDefaultCheckedChange = (keyPath, value) => {
    this.props.onFieldValueChange(keyPath, (value === 'checked'));
  }

  onOptInValueChange = (keyPath, value) => {
    this.props.onFieldValueChange(keyPath, value);

    if (!value) {
      this.props.fieldValidityChanged([...this.props.keyPath, 'optInData', 'optInValue'], false, ERROR_TEXT_EMPTY_REQUIRED_FIELD);
    } else {
      this.props.fieldValidityChanged([...this.props.keyPath, 'optInData', 'optInValue'], true);
    }
  }

  render() {
    const {
      values: { editors: { optInData }, type },
      uiState,
      keyPath,
      onFieldUIStateChange,
      onFieldValueChange,
      sfFieldData,
    } = this.props;
    let pickListValueMap = {};

    if (type === FIELD_TYPES.BOOLEAN_OPT_IN) {
      const fieldName = this.props.values.name;
      pickListValueMap = { [fieldName]: fieldName };
    } else if (sfFieldData.lead_share_opt_in) {
      pickListValueMap = sfFieldData.lead_share_opt_in.sfPicklistValues.reduce((acc, cur) => {
        acc[cur.value] = cur.label;
        return acc;
      }, {});
    }
    const formatBoxDisabled = !optInData.hasCheckbox ||
      (this.props.values.name === FIELD_NAMES.LEAD_SHARE_OPT_IN && [GDPR_SETTING.ALWAYS, GDPR_SETTING.ALWAYS_IMPLIED].includes(this.props.gdprSetting));
    const optInLabel = this.props.values.name === FIELD_NAMES.CONSENT_NON_GDPR ? 'Prospect share opt-in checkbox and language' : 'Opt-In Language';
    return (
      <div className="row pr-5 pb-3">
        <div className="col mt-2">
          <div className="row mb-4">
            <div className="col mt-2">
              <CheckBoxAttribute
                disabled={false}
                keyPath={[...keyPath, 'optInData', 'hasDisclaimer']}
                onCheckBoxChange={this.onDisclaimerCheckboxChange}
                value={optInData.hasDisclaimer}
                labelledBy={generateHTMLIdFromKeyPath([...keyPath, 'optInData', 'disclaimer']).concat(LABEL_SUFFIX)}
                className="mt-1"
              />
              <div className="ml-4">
                <InputContainer
                  label="Include Disclaimer language"
                  keyPath={[...keyPath, 'optInData', 'disclaimer']}
                  uiState={uiState.editors.optInData.disclaimer}
                  disabled={!optInData.hasDisclaimer}
                >
                  <TextAreaAttribute
                    keyPath={[...keyPath, 'optInData', 'disclaimer']}
                    value={optInData.disclaimer}
                    disabled={!optInData.hasDisclaimer}
                    onFieldValueChange={this.onDisclaimerTextChange}
                    onFieldUIStateChange={onFieldUIStateChange}
                    placeholder={optInData.hasDisclaimer ? 'Disclaimer language must be filled out if checked' : null}
                  />
                </InputContainer>
              </div>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col mt-2">
              {this.props.values.name === FIELD_NAMES.CONSENT_NON_GDPR ?
                (
                  <CheckBoxAttribute
                    disabled={false}
                    keyPath={[...keyPath, 'optInData', 'hasCheckbox']}
                    onCheckBoxChange={this.onProspectShareCheckboxChange}
                    value={optInData.hasCheckbox}
                    labelledBy={generateHTMLIdFromKeyPath([...keyPath, 'optInData', 'checkboxText']).concat(LABEL_SUFFIX)}
                    className="mt-1"
                  />
                ) : null}
              <div className="ml-4">
                <InputContainer
                  label={optInLabel}
                  keyPath={[...keyPath, 'optInData', 'checkboxText']}
                  uiState={uiState.editors.optInData.checkboxText}
                  disabled={!optInData.hasCheckbox} // When US Consent fields are deprecated by impled consent, this line (and all uses of hasCheckbox) can be removed
                >
                  <TextAreaAttribute
                    keyPath={[...keyPath, 'optInData', 'checkboxText']}
                    value={optInData.checkboxText}
                    disabled={!optInData.hasCheckbox}
                    onFieldValueChange={this.onProspectShareTextChange}
                    onFieldUIStateChange={onFieldUIStateChange}
                    placeholder={optInData.hasCheckbox ? 'Prospect share language must be filled out if checked' : null}
                  />
                </InputContainer>
              </div>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-lg-6 mt-2 mb-4 mb-lg-0">
              <p className="font-weight-bold mb-1 ml-4">Format</p>
              <div className="row ml-4 mr-2 border-left border-secondary">
                <div className="col-sm-6 py-3 border border-secondary border-left-0">
                  <RadioButtonAttribute
                    disabled={formatBoxDisabled}
                    field={OPTIN_FORMATS.CHECKBOX}
                    keyPath={[...keyPath, 'optInData', 'format']}
                    label="Checkbox"
                    onRadioButtonChange={onFieldValueChange}
                    radioGroupName="Input Type"
                    value={optInData.format === OPTIN_FORMATS.CHECKBOX}
                    omitBorder
                    stacked
                  />
                  <div className="mx-4 my-2">
                    <RadioGroupContainer
                      disabled={formatBoxDisabled || optInData.format !== OPTIN_FORMATS.CHECKBOX}
                      radioGroupName="Default Value"
                      stacked
                      uiState={this.props.uiState}
                    >
                      <RadioButtonAttribute
                        disabled={formatBoxDisabled || optInData.format !== OPTIN_FORMATS.CHECKBOX}
                        field="checked"
                        keyPath={[...keyPath, 'optInData', 'defaultChecked']}
                        label="Checked"
                        onRadioButtonChange={this.onDefaultCheckedChange}
                        radioGroupName="Default Value"
                        value={optInData.defaultChecked}
                        omitBorder
                        stacked
                      />
                      <RadioButtonAttribute
                        disabled={formatBoxDisabled || optInData.format !== OPTIN_FORMATS.CHECKBOX}
                        field="unchecked"
                        keyPath={[...keyPath, 'optInData', 'defaultChecked']}
                        label="Unchecked"
                        onRadioButtonChange={this.onDefaultCheckedChange}
                        radioGroupName="Default Value"
                        value={!optInData.defaultChecked}
                        omitBorder
                        stacked
                      />
                    </RadioGroupContainer>
                  </div>
                </div>
                <div className="col-sm-6 py-3 border border-secondary border-left-0">
                  <RadioButtonAttribute
                    disabled={formatBoxDisabled}
                    field={OPTIN_FORMATS.RADIO}
                    keyPath={[...keyPath, 'optInData', 'format']}
                    label="Radio"
                    onRadioButtonChange={onFieldValueChange}
                    radioGroupName="Input Type"
                    value={optInData.format === OPTIN_FORMATS.RADIO}
                    omitBorder
                    stacked
                  />
                  <div className="mx-4 my-2">
                    <RadioGroupContainer
                      disabled={formatBoxDisabled || optInData.format !== OPTIN_FORMATS.RADIO}
                      radioGroupName="Default Value"
                      stacked
                      uiState={this.props.uiState}
                    >
                      <RadioButtonAttribute
                        disabled={formatBoxDisabled || optInData.format !== OPTIN_FORMATS.RADIO}
                        field={OPTIN_RADIO_DEFAULTS.NONE}
                        keyPath={[...keyPath, 'optInData', 'defaultRadio']}
                        label="None"
                        onRadioButtonChange={onFieldValueChange}
                        radioGroupName="Default Value"
                        value={optInData.defaultRadio === OPTIN_RADIO_DEFAULTS.NONE}
                        omitBorder
                        stacked
                      />
                      <RadioButtonAttribute
                        disabled={formatBoxDisabled || optInData.format !== OPTIN_FORMATS.RADIO}
                        field={OPTIN_RADIO_DEFAULTS.YES}
                        keyPath={[...keyPath, 'optInData', 'defaultRadio']}
                        label="Yes"
                        onRadioButtonChange={onFieldValueChange}
                        radioGroupName="Default Value"
                        value={optInData.defaultRadio === OPTIN_RADIO_DEFAULTS.YES}
                        omitBorder
                        stacked
                      />
                      <RadioButtonAttribute
                        disabled={formatBoxDisabled || optInData.format !== OPTIN_FORMATS.RADIO}
                        field={OPTIN_RADIO_DEFAULTS.NO}
                        keyPath={[...keyPath, 'optInData', 'defaultRadio']}
                        label="No"
                        onRadioButtonChange={onFieldValueChange}
                        radioGroupName="Default Value"
                        value={optInData.defaultRadio === OPTIN_RADIO_DEFAULTS.NO}
                        omitBorder
                        stacked
                      />

                    </RadioGroupContainer>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 ml-4 ml-lg-0 mt-2">
              <InputContainer
                disabled={!optInData.hasCheckbox}
                label="Lead Share Opt-In Value"
                keyPath={[...keyPath, 'optInData', 'optInValue']}
                uiState={uiState.editors.optInData.optInValue}
              >
                <SelectAttribute
                  disabled={!optInData.hasCheckbox}
                  keyPath={[...keyPath, 'optInData', 'optInValue']}
                  value={optInData.optInValue}
                  options={pickListValueMap}
                  onFieldValueChange={this.onOptInValueChange}
                  onFieldUIStateChange={onFieldUIStateChange}
                />
              </InputContainer>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FieldConfigureOptIn.propTypes = {
  fieldValidityChanged: PropTypes.func.isRequired,
  gdprSetting: PropTypes.string.isRequired,
  values: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    editors: PropTypes.shape({
      optInData: PropTypes.shape({
        checkboxText: PropTypes.string,
        defaultChecked: PropTypes.bool,
        defaultRadio: PropTypes.string,
        disclaimer: PropTypes.string,
        format: PropTypes.string,
        hasCheckbox: PropTypes.bool,
        hasDisclaimer: PropTypes.bool,
        optInValue: PropTypes.string,
      }),
    }).isRequired,
  }).isRequired,
  uiState: PropTypes.object.isRequired,
  keyPath: PropTypes.array.isRequired,
  onFieldUIStateChange: PropTypes.func.isRequired,
  onFieldValueChange: PropTypes.func.isRequired,
  sfFieldData: PropTypes.objectOf(
    PropTypes.shape({
      sfPicklistValues: PropTypes.array,
    }).isRequired,
  ),
};

FieldConfigureOptIn.defaultProps = {
  sfFieldData: {
    sfPicklistValues: [],
  },
};

function makeFieldConfigOptIn(props) {
  return (<FieldConfigureOptIn {...props} />);
}

export default makeFieldConfigOptIn;
